if (!customElements.get('request-size')) {
  customElements.define(
    'request-size',
    class RequestSize extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.apiBaseUrl = 'https://a.klaviyo.com/client/';
        this.apiCompanyId = '/?company_id=RPk5HM';
        this.selectors = {
          successMessage: '.request-size-form__message-text--success',
          errorMessage: '.request-size-form__message-text--error',
          fadeIn: 'fade-in',
        };

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      async handleSubmit(evt) {
        evt.preventDefault();

        try {
          const backInStockResponse = await fetch(
            `${this.apiBaseUrl}back-in-stock-subscriptions${this.apiCompanyId}`,
            this.getRequestOptions('backInStock'),
          );
          const profileResponse = await fetch(`${this.apiBaseUrl}profiles${this.apiCompanyId}`, this.getRequestOptions('profile'));
          if (backInStockResponse.ok && profileResponse.ok) this.querySelector(this.selectors.successMessage).classList.add(this.selectors.fadeIn);
          else this.querySelector(this.selectors.errorMessage).classList.add(this.selectors.fadeIn);
        } catch {
          this.querySelector(this.selectors.errorMessage).classList.add(this.selectors.fadeIn);
        }
      }

      getRequestOptions(payload = 'backInStock' || 'profile') {
        const { email, first_name, last_name, country, requested_size } = Object.fromEntries(new FormData(this.form));

        const backInStockPayload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                  },
                },
              },
              channels: [
                'EMAIL',
              ],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${requested_size}`,
                },
              },
            },
          },
        };

        const profilePayload = {
          data: {
            type: 'profile',
            attributes: {
              email,
              first_name,
              last_name,
              location: {
                country,
              },
            },
          },
        };

        return {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-05-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify(payload === 'backInStock' ? backInStockPayload : profilePayload),
        };
      }
    },
  );
}
